import React from 'react';

export const BatchClassificationBar: React.FC<{
  selectedCount: number;
  classificationBatchInput: string;
  onBatchInputChange: (v: string) => void;
  onAddBatch: () => void;
  adding: boolean;
  classificationToRemove: string;
  onClassificationToRemoveChange: (v: string) => void;
  removeOptions: string[];
  onRemoveBatch: () => void;
  removing: boolean;
  onDeselectAll: () => void;
}> = ({
  selectedCount,
  classificationBatchInput,
  onBatchInputChange,
  onAddBatch,
  adding,
  classificationToRemove,
  onClassificationToRemoveChange,
  removeOptions,
  onRemoveBatch,
  removing,
  onDeselectAll,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem',
      marginBottom: '1rem',
      padding: '0.5rem',
      background: '#f0f4ff',
      borderRadius: 8,
    }}
  >
    <input
      type="text"
      value={classificationBatchInput}
      onChange={(e) => onBatchInputChange(e.target.value)}
      placeholder="Classification to add (e.g. upright, vertical)"
      style={{
        padding: '0.5rem 0.75rem',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        width: '200px',
        maxWidth: '100%',
        fontSize: '0.9rem',
      }}
      onKeyDown={(e) => e.key === 'Enter' && onAddBatch()}
    />
    <button
      type="button"
      title="Writes labels to Postgres via ingestion; does not modify the DVC CSV on disk"
      onClick={onAddBatch}
      disabled={adding || !classificationBatchInput.trim()}
      style={{
        padding: '0.5rem 1rem',
        background: classificationBatchInput.trim() && !adding ? '#667eea' : '#ccc',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: adding || !classificationBatchInput.trim() ? 'not-allowed' : 'pointer',
      }}
    >
      {adding ? 'Saving to DB...' : `Add Classifications to DB (${selectedCount})`}
    </button>
    <select
      value={classificationToRemove}
      onChange={(e) => onClassificationToRemoveChange(e.target.value)}
      disabled={removeOptions.length === 0}
      style={{
        padding: '0.5rem 0.75rem',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        fontSize: '0.9rem',
        minWidth: '160px',
        background: removeOptions.length > 0 ? '#fff' : '#f5f5f5',
      }}
      title={
        removeOptions.length === 0
          ? 'No classifications on selected images'
          : 'Classification to remove from all selected'
      }
    >
      <option value="">
        {removeOptions.length === 0
          ? 'No classifications on selected'
          : 'Classification to remove...'}
      </option>
      {removeOptions.map((c) => (
        <option key={c} value={c}>
          {c}
        </option>
      ))}
    </select>
    <button
      type="button"
      onClick={onRemoveBatch}
      disabled={removing || !classificationToRemove.trim()}
      style={{
        padding: '0.5rem 1rem',
        background: classificationToRemove.trim() ? '#dc3545' : '#ccc',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: removing || !classificationToRemove.trim() ? 'not-allowed' : 'pointer',
      }}
    >
      {removing ? 'Removing...' : 'Remove classification'}
    </button>
    <button
      type="button"
      onClick={onDeselectAll}
      style={{
        padding: '0.5rem 1rem',
        background: '#6c757d',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      Deselect all
    </button>
  </div>
);
